import { render, staticRenderFns } from "./RegisterTouristInfo.vue?vue&type=template&id=11bfcb0c&scoped=true&"
import script from "./RegisterTouristInfo.vue?vue&type=script&lang=js&"
export * from "./RegisterTouristInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTouristInfo.vue?vue&type=style&index=0&id=11bfcb0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bfcb0c",
  null
  
)

export default component.exports